<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">Dedication</p>
<p class="ded"><i>To the kindred spirits out there who find peace, enjoyment, and a sense of fulfillment in the simple act of attaching a single bead, finding the perfect thread, and creating sumptuous seam treatments</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?9c4d101e